import { render } from "./IconForm.vue?vue&type=template&id=4c825ff0"
import script from "./IconForm.vue?vue&type=script&lang=js"
export * from "./IconForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__